import { render, staticRenderFns } from "./ActivityParticipatingElderGrowthTrend.vue?vue&type=template&id=5cb08ec6&scoped=true&"
import script from "./ActivityParticipatingElderGrowthTrend.vue?vue&type=script&lang=js&"
export * from "./ActivityParticipatingElderGrowthTrend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb08ec6",
  null
  
)

export default component.exports